module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-2-db2fddfd654dd8b28ca2e76eae46add3.svg";